<template>
 <div class="bg-white min-h-screen">
  <slot />
  </div>
</template>